import React, { useRef } from 'react';
import useCookies from '../../../hooks/useCookies';
import ButtonText from '../../buttons/button.text';
import LinkText from '../../buttons/link.text';
import './pricing.section.scss';

const PricingSectionML = () => {

    const { profileid } = useCookies();

    const goToRegister = () => {
        const action = profileid ? 'CTA_Returning' : 'CTA_New'
        const label = profileid ? 'Returning user clicks ML CTA' : 'New user clicks ML CTA'
        const value = profileid ? 0 : 2;
        if (window?.gtag) {
            window.gtag('event', action, {
                event_category: 'ML',
                event_label: label,
                value: value,
            });
        }
        return true;
    }

    return (
        <div id="PricingSection" className='ML'>
            <div className="PRICE">
                <div className="_priceEntry">
                    <h3>MENSUALIDAD</h3>
                    <h2 className="_amount">
                        $0
                        <span className="_currency">
                            MXN
                        </span>
                    </h2>
                    <p>
                        Sin mensualidad
                    </p>
                </div>
                <div className="_divider" />
                <div className="_priceEntry">
                    <h3>Costo por Factura</h3>
                    <h2 className="_amount">
                        $2.95
                        <span className="_currency">
                            MXN
                        </span>
                    </h2>
                    <p>
                        Costo por factura.
                    </p>
                    <p>
                        Factura a cliente & Factura global
                    </p>
                </div>
                <p className="_ivaIncluded">
                    IVA incluído <br/>
                    <span>
                        Cancelaciones y notas de crédito gratuitas.
                    </span>
                </p>
            </div>

            <div className="_cta">
                <LinkText onClick={goToRegister} color='yellow' type='primary' to="https://auth.mercadolibre.com.mx/authorization?response_type=code&amp;client_id=1872542609212539&amp;redirect_uri=https://mercadolibre.fiscalpop.com/auth">
                    <span>
                        Registra Tu Cuenta
                    </span>
                </LinkText>

                <LinkText color='yellow' type="tertiary" to="/ecommerce/compare">
                    <span>
                        Compara con las demás integraciones
                    </span>
                </LinkText>
            </div>
        </div>
    )
}

export default PricingSectionML;